/**
 * Browser-safe schema imports
 * Pulled directly from shared package — do not maintain local copies.
 */

import certificatesOpenApi from './certificates-openapi.json';
import mtlsOpenApi from '@rail-delivery-group/account-customisation-shared/dist/schema/mtls-openapi.json';
import iamM2mOpenApi from '@rail-delivery-group/account-customisation-shared/dist/schema/iam-m2m-openapi.json';

export const CERTIFICATES_OPENAPI = certificatesOpenApi;
export const MTLS_OPENAPI = mtlsOpenApi;
export const IAM_M2M_OPENAPI = iamM2mOpenApi;

export type CertificatesOpenAPI = typeof certificatesOpenApi;
export type MtlsOpenAPI = typeof mtlsOpenApi;
export type IamM2mOpenAPI = typeof iamM2mOpenApi;
